jQuery($ => {

    if ($('.o-choose-one')[0]) {
        $('.o-choose-one .a-checkbox__input').change(function () {
            const $container = $(this).closest('.o-choose-one__choices');
            const $choice = $(this).closest('.o-choose-one__choice');
            const $otherChoice = $container.find('.o-choose-one__choice').not($choice);

            $choice.toggleClass('o-choose-one__choice--checked');

            if (!$(this).parent().hasClass('a-checkbox--checked')) {
                $choice.removeClass('o-choose-one__choice--not-checked');
                $otherChoice.addClass('o-choose-one__choice--not-checked');
                $otherChoice.removeClass('o-choose-one__choice--checked');
                $otherChoice.find('.a-checkbox__input:checked').prop('checked', false);
                $otherChoice.find('.a-checkbox').removeClass('a-checkbox--checked');
            } else {
                $otherChoice.removeClass('o-choose-one__choice--not-checked');
            }
        });
    }

});